import { pathJoin } from 'src/reducers/routing/utils'

export const createDetailRoutesMap = (prefix: string) => ({
  containers: pathJoin(prefix)('containers').chain,
  'collection-log': pathJoin(prefix)('collection-log').chain,
  // PRO-946 (HRA req 1.2.5): the customer's environmental account
  // (miljøregnskap); gated on the ui.customers.environmental_account switch.
  'environmental-account': pathJoin(prefix)('environmental-account').chain,
  history: pathJoin(prefix)('history').chain,
  tickets: pathJoin(prefix)('tickets').chain,
  invoices: pathJoin(prefix)('invoices').chain,
  overview: pathJoin(prefix)('overview').chain,
  notes: pathJoin(prefix)('notes').chain,
  calendar: pathJoin(prefix)('calendar').chain,
  subscriptions: pathJoin(prefix)('subscriptions').chain,
  'export-runs': pathJoin(prefix)('export-runs').chain,
  contacts: pathJoin(prefix)('contacts').chain,
  companies: pathJoin(prefix)('companies').chain,
  agreements: pathJoin(prefix)('agreements').chain,
  // PRODUCT-454: the property's Rentals tab (Inventory module on); the
  // Agreements tab's "Temporary rental" chips link here (PRODUCT-455).
  rentals: pathJoin(prefix)('rentals').chain,
  // PRODUCT-489: the property's Permits tab (public-road skip permits;
  // Inventory module on).
  permits: pathJoin(prefix)('permits').chain,
  'standalone-contacts': pathJoin(prefix)('standalone-contacts').chain,
  'shared-service': pathJoin(prefix)('shared-service').chain,
  'waste-water': pathJoin(prefix)('waste-water').chain,
  keys: pathJoin(prefix)('keys').chain,
  'composting-registries': pathJoin(prefix)('composting-registries').chain,
})
